import { Component, EventEmitter, Input, OnDestroy, Output } from '@angular/core';
import { DialerButtonValue } from './dialer-button.model';

const LONG_PRESS_MS = 500;

@Component({
  selector: 'dialer-button',
  templateUrl: './dialer-button.component.html',
  styleUrls: ['./dialer-button.component.scss']
})
export class DialerButtonComponent implements OnDestroy {

  @Input() key: DialerButtonValue = null;
  @Output() buttonPressed: EventEmitter<DialerButtonValue> = new EventEmitter();

  private longPressTimer: ReturnType<typeof setTimeout> | null = null;
  private longPressTriggered = false;

  public onPressStart(): void {
    if (!this.key.chars || this.key.chars.length !== 1) return;
    this.longPressTriggered = false;
    this.longPressTimer = setTimeout(() => {
      this.longPressTriggered = true;
      this.buttonPressed.emit({ key: this.key.chars! });
    }, LONG_PRESS_MS);
  }

  public onPressEnd(): void {
    if (this.longPressTimer) {
      clearTimeout(this.longPressTimer);
      this.longPressTimer = null;
    }
    if (!this.longPressTriggered) {
      this.buttonPressed.emit(this.key);
    }
    this.longPressTriggered = false;
  }

  public onPressCancel(): void {
    if (this.longPressTimer) {
      clearTimeout(this.longPressTimer);
      this.longPressTimer = null;
    }
    this.longPressTriggered = false;
  }

  public onTouchStart(event: TouchEvent): void {
    event.preventDefault();
    this.onPressStart();
  }

  ngOnDestroy(): void {
    this.onPressCancel();
  }

}
